import React from 'react';
import Icon from 'components/Common/Icons/Icon/Icon';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconCheckMark = ({ className }: Props) => (
  <Icon className={className}>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="M7.6 13.2L14.65 6.15L13.25 4.75L7.6 10.4L4.75 7.55L3.35 8.95L7.6 13.2ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H2Z"
        fill="#383838"
      />
    </svg>
  </Icon>
);

export default IconCheckMark;
